module.exports = __webpack_public_path__ + "img/web2icon6.4f0b3953.png";